import Http from "./http";

export const getEnrollmentAgreementDetailsAPI = (payload, options) => {
  return Http.post("admin/campaign/enrollment-agreement/get", payload, options);
};

